export const redirectToApp = (to: string) => {
  window.location.href = to;
};
